import React from "react";

import "../styles/Beneficios.css";

import { GiBrain, GiReceiveMoney, GiPadlock } from "react-icons/gi";
import { TbChartInfographic } from "react-icons/tb";



function Beneficios() {
  return (
    <div className="containerBeneficios">
      <div className="headerTitleBeneficios">
        <h1>Nossos benefícios</h1>
      </div>
      <div className="blocosBeneficios">
        <div className="bloco">
          <GiBrain className="iconBloco"/>
          <h2>Agendamento Inteligente</h2>
          <p>Gerencie horários com facilidade e reduza erros.</p>
        </div>
        <div className="bloco">
          <GiReceiveMoney className="iconBloco"/>
          <h2>Controle Financeiro</h2>
          <p>Tenha uma visão clara de entradas, saídas e faturamento.</p>
        </div>
        <div className="bloco">
          <TbChartInfographic className="iconBloco"/>
          <h2>Relatórios Estratégicos</h2>
          <p>Tome decisões baseadas em dados reais do seu consultório.</p>
        </div>
        <div className="bloco">
          <GiPadlock className="iconBloco"/>
          <h2>Segurança de Dados</h2>
          <p>Informações protegidas e acessíveis de qualquer lugar.</p>
        </div>
      </div>
    </div>
  );
}

export default Beneficios;
